function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "basic_elaboration_document_check",
  transform: "translate(-7 1)"
}, React.createElement("path", {
  id: "Path_51",
  d: "M42.153 0H18.378L8 10.378v35.159h34.153zM17.961 2.429v7.532h-7.532zM40.73 44.114H9.423v-32.73h9.961V1.423H40.73z",
  className: "cls-1"
}), React.createElement("path", {
  id: "Path_52",
  d: "M23.3 33.583l-1.006 1.111 4.981 5.085h1.005l9.25-9.354-1.006-1.059-8.747 8.721z",
  className: "cls-1",
  transform: "translate(-4.123 -8.472)"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 36.153,
    height: 47.537,
    viewBox: "0 0 36.153 47.537"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/doc.3e8b7e0c.svg";
export { SvgComponent as ReactComponent };